import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import { LearnerInternshipForm } from '../../etqa/program/registration/LearnerInternshipForm';

const InternshipRef = React.createRef();
const utils = new ViewUtils();

class AddLearnerInternship extends Component {

    state = {
        InternshipDetails: {
            SAQAQualificationTitle: "",
            SAQAQualificationID: ""
        },
        messageStyle: "message",
        id: null,
        showTable: true,
        CurrentProgramme: this.props.location.state.InternshipID,
        CreateNewFlag: this.props.location.state.hideFields,
        Learner: this.props.location.state.LearnerID,
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: '', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', icon: 'SaveIcon' },
                        { id: 'documents', label: 'DOCUMENTS', tooltip: 'Documents', disabled: (this.props.location.state.hideFields), visible: !(this.props.location.state.hideFields) }
                    ]
                }
            ]
        },
        model:{ },
    };


    componentDidMount() {
        if (utils.isNull(this.props.location.state.InternshipID) || this.props.location.state.InternshipID === 0)
        {
            this.defaultSponsorship()
        }
    }

    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {
            //if (!utils.isNull(values.InternshipStartDate)) {
            //    utils.autoSetDate(this, InternshipRef, values.InternshipStartDate, 2, 0, -1, "InternshipEndDate", "InternshipStartDate")
            //}


            this.setState({
                InternshipSetupDetails: {
                    SAQAQualificationID: values.SAQAQualificationID,
                    SAQAQualificationTitle: values.SAQAQualificationTitle
                },
                Learner: this.props.location.state.LearnerID
            });

            this.ECCheck(values);
        }
    }

    ECCheck(values) {
        if (!utils.isNull(values)) {
            if (!utils.isNull(values.EmployerID)) {
                let url = "api/sims/learner/EmployerContactCheck?EmployerID=" + values.EmployerID.Id;
                utils.invokeUrl(url, (response) => {
                    if (response.Result != "") {
                        this.setState({
                            message: response.Result,
                            messageStyle: "ERROR",
                        })
                    }
                },
                    null,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        }
                    }
                )
            }
        }
    }

    dateChange = (form, date) => {
        if (!utils.isNull(form.values.InternshipStartDate)) {
            utils.autoSetDate(this, InternshipRef, form.values.InternshipStartDate, 2, 0, -1, "InternshipEndDate", "InternshipStartDate")
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("documents" === buttonId) {
            this.props.history.push({
                pathname: '/learnerInternshipDocuments',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    LearnerInternshipID: this.props.location.state.InternshipID,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.location.state.permissions
                }
            });
        }
    }

    successCallback = (response) => {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    CurrentProgramme: response.EntityId,
                    CreateNewFlag: false
                })
            });
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    defaultSponsorship = () => {
        let url = "api/sims/learnerinternship/GetCurrentRole";
        utils.invokeUrl(url, (response) => {
            if (response.Result === "Provider" || response.Result === "AET Agent" || response.Result === "Agent") {
                this.setState({
                    model: {
                        SponsorshipID: { Id: 2, Description: "Industry Funded" }
                    }
                })
            }
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    save() {
        let formValue = InternshipRef.current.getValue();
        console.log(formValue);
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.LearnerID;
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerinternship/LinkLearnerInternship", (response) => {
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {

        this.props.history.push({
            pathname: '/LearnerInternshipsSearch',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {
                        (this.props.location.state.hideFields) ?
                            `Learner > Link New Internship > ${this.props.location.state.learnerNames}`
                            :
                            `Learner > Update Internship > ${this.props.location.state.learnerNames}`
                    }
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "60vh" }}>
                                    {this.state.showTable === true && (
                                        <LearnerInternshipForm ref={InternshipRef}
                                            viewRef={this}
                                            id={this.state.CurrentProgramme}
                                            editPermission={this.props.location.state.permissions}
                                            viewOnly={this.props.location.state.viewOnly}
                                            hideFields={this.state.CreateNewFlag}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                            dateChange={this.dateChange}
                                            model={this.state.model}
                                            data={this.state.model}
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddLearnerInternship);
